import React, { Dispatch, useCallback, useEffect, useState } from "react";
import { ActionList, Button, ButtonGroup, FormLayout, InlineStack, Modal, Popover, Select, Text, TextField, BlockStack } from "@shopify/polaris";
import { CirclePlusMinor } from "@shopify/polaris-icons";
import { DI, DIProps } from "../../../../Core";
import { useTranslation } from "react-i18next";
interface PropsI extends DIProps {
    pckg_dimension: { length: string, width: string, height: string, unit: string, error: boolean },
    setPckg: Dispatch<React.SetStateAction<{ length: string, width: string, height: string, unit: string, error: boolean }>>
    data: any;
    data_loading: boolean
}

const Package_Dimension = (props: PropsI) => {
    const { t } = useTranslation();
    const [popoverActive, setPopoverActive] = useState(false);

    const [activeDimensionModal, setActiveDimensionModal] = useState(false);
    const [list, setList] = useState<any[]>([])
    const [textFieldValue, setTextFieldValue] = useState({ length: '', width: '', height: '', unit: 'CENTIMETER', error: false });
    const [edited, setEdited] = useState(false)

    const handleTextFieldChange = useCallback((value: string, id: string) => {
        value = value.replace(/[a-zA-Z-!$%^&*()@_+|~=`\\#{}\[\]:";'<>?,\/]/gi, '');
        value = value?.[0] === '.' ? '0' + value : value;
        value = value === '00' ? '0' : value;
        value = (value.split(".").length - 1 > 1 ? value.slice(0, -1) : value).replace(/^(\d+.?\d{0,2})\d*$/, "$1");
        setTextFieldValue(a => ({ ...a, [id]: value }))
    }, []);

    const handleSelectChange = useCallback((value: string) => {
        setTextFieldValue(a => ({ ...a, unit: value }))
    }, []);

    const saveDimension = () => {
        if (!textFieldValue.length || !textFieldValue.width || !textFieldValue.height) {
            setTextFieldValue(a => ({ ...a, error: true }))
            return;
        }

        let packages = [...list.map((item) => item.additional_data)]
        if (edited) {
            packages = packages.map((pckge: any) => {
                if (pckge?.length === props.pckg_dimension.length && pckge?.width === props.pckg_dimension.width && pckge?.height === props.pckg_dimension.height) {
                    pckge = { ...textFieldValue }
                }
                return pckge
            })
        } else {
            packages = [textFieldValue, ...packages]
        }
        packages = packages.filter((pckge, index) => {
            return index === packages.findIndex(o => pckge?.length === o.length && pckge?.width === o.width && pckge?.height === o.height);
        });
        setList([...packages.map((pckg: any) => {
            let val = {
                length: pckg?.length ?? '',
                width: pckg?.width ?? '',
                height: pckg?.height ?? '',
                unit: pckg?.unit ?? 'CENTIMETER', error: false
            }
            if (!val.length || !val.width || !val.height) return;
            let content = `${val.length} ${val.unit} X ${val.width} ${val.unit} X ${val.height} ${val.unit}`
            return {
                content: content, additional_data: val, onAction: () => {
                    props.setPckg({ ...val, error: false });
                    setPopoverActive(false)
                }
            }
        }).filter((a: any) => a)])
        props.di.POST('connector/profile/createUpdateTemplate', {
            "name": "shipping_details",
            "type": "shipping_services",
            "marketplace": "amazon",
            "use_user_id": true,
            "user_id": props.redux.user_id,
            "packages": packages
        },).then((response) => {
            if (!response.success) props.error(t(response.message) ?? '')
        })
        setEdited(false)
        setActiveDimensionModal(false);
        props.setPckg({ ...textFieldValue, error: false });
        setTextFieldValue(a => ({ ...a, length: '', width: '', height: '', error: false }));
        // const value = `${textFieldValue.length} ${textFieldValue.unit} X ${textFieldValue.width} ${textFieldValue.unit} X ${textFieldValue.height} ${textFieldValue.unit}`
        // if (!list.find((item) => item.content.includes(value)))
        //     setList([{ content: value, additional_data: textFieldValue, onAction: () => { props.setPckg({ ...textFieldValue, error: false }) } }, ...list])
    }

    useEffect(() => {
        let temp_list = [...(props.data?.template_data?.packages ?? []), props.pckg_dimension, ...list.map((item) => item.additional_data)]
        const unique = temp_list.filter((pckge, index) => {
            return index === temp_list.findIndex(o => pckge?.length === o.length && pckge?.width === o.width && pckge?.height === o.height);
        });
        setList([...unique.map((pckg: any) => {
            let val = {
                length: pckg?.length ?? '',
                width: pckg?.width ?? '',
                height: pckg?.height ?? '',
                unit: pckg?.unit ?? 'CENTIMETER', error: false
            }
            if (!val.length || !val.width || !val.height) return;
            let content = `${val.length} ${val.unit} X ${val.width} ${val.unit} X ${val.height} ${val.unit}`
            return {
                content: content, additional_data: val, onAction: () => {
                    props.setPckg({ ...val, error: false });
                    setPopoverActive(false)
                }
            }
        }).filter((a: any) => a)])
    }, [props.data?.template_data, props.pckg_dimension])

    const pckg_dimension_selected = props.pckg_dimension.length && props.pckg_dimension.width && props.pckg_dimension.height
    const label_generated = !!props.data?.shipping_services?.[0]?.label_generated

    const activator = (
        <Button textAlign='left' fullWidth onClick={() => { props.setPckg(a => ({ ...a, error: false })); setPopoverActive(a => !a) }} disclosure tone={props.pckg_dimension.error ? 'critical' : undefined} variant={props.pckg_dimension.error ? 'primary' : undefined}>
            {pckg_dimension_selected ? `${props.pckg_dimension.length} ${props.pckg_dimension.unit} X ${props.pckg_dimension.width} ${props.pckg_dimension.unit} X ${props.pckg_dimension.height} ${textFieldValue.unit}` : t('Select from previously filled dimensions or create a new dimension')}
        </Button>
    );

    return <>
        {!label_generated && <Popover
            fullWidth
            active={popoverActive}
            activator={activator}
            autofocusTarget="first-node"
            onClose={() => { setPopoverActive(false) }}

        >
            <Popover.Pane>
                <ActionList
                    actionRole="menuitem"
                    items={list}
                />
            </Popover.Pane>
            <Popover.Pane>
                <ActionList
                    actionRole="menuitem"
                    items={[
                        { content: t('Add new dimension'), icon: CirclePlusMinor, onAction: () => setActiveDimensionModal(true) },
                    ]}
                />
            </Popover.Pane>
        </Popover>}
        {pckg_dimension_selected &&
            <InlineStack align='space-between' blockAlign='start'>
                <BlockStack gap="200">
                    <Text variant="headingSm" as="h6">
                        {t("Selected Dimension")}
                    </Text>
                    <BlockStack gap="0">
                        <Text as="p" fontWeight="regular">
                            {`${props.pckg_dimension.length} ${props.pckg_dimension.unit} X ${props.pckg_dimension.width} ${props.pckg_dimension.unit} X ${props.pckg_dimension.height} ${props.pckg_dimension.unit}`}
                        </Text>
                    </BlockStack>
                </BlockStack>
                {!label_generated && <ButtonGroup>
                    <Button variant='plain' onClick={() => {
                        setTextFieldValue(props.pckg_dimension)
                        setActiveDimensionModal(true)
                        setEdited(true)
                    }}>{t("Edit")}</Button>
                    <Button variant='plain' tone="critical" onClick={() => { props.setPckg(a => ({ ...a, length: '', width: '', height: '', error: false })) }}>{t("Remove")}</Button>
                </ButtonGroup>}
            </InlineStack>
        }
        <Modal
            size="large"
            open={activeDimensionModal}
            onClose={() => {
                setTextFieldValue(a => ({ ...a, height: '', length: '', width: '', error: false }))
                setActiveDimensionModal(false)
                setEdited(false)
            }}
            title={t("New Package Dimension")}
            primaryAction={{
                content: t('Save'),
                onAction: () => saveDimension(),
            }}
        >
            <Modal.Section>
                <FormLayout>
                    <FormLayout.Group condensed>
                        <TextField
                            label={t("Length")}
                            id='length'
                            value={textFieldValue.length}
                            onChange={handleTextFieldChange}
                            autoComplete="off"
                            error={textFieldValue.error && !textFieldValue.length}
                            connectedLeft={
                                <Select
                                    value={textFieldValue.unit}
                                    label={t("Weight unit")}
                                    onChange={handleSelectChange}
                                    labelHidden
                                    options={[{ label: t('cm'), value: 'CENTIMETER' }, { label: t('in'), value: 'INCH' }]}
                                />
                            }
                        />
                        <TextField
                            label={t("Width")}
                            id='width'
                            value={textFieldValue.width}
                            onChange={handleTextFieldChange}
                            autoComplete="off"
                            error={textFieldValue.error && !textFieldValue.width}
                            connectedLeft={
                                <Select
                                    value={textFieldValue.unit}
                                    label={t("Weight unit")}
                                    onChange={handleSelectChange}
                                    labelHidden
                                    options={[{ label: t('cm'), value: 'CENTIMETER' }, { label: t('in'), value: 'INCH' }]}
                                />
                            }
                        />
                        <TextField
                            label={t("Height")}
                            id='height'
                            value={textFieldValue.height}
                            onChange={handleTextFieldChange}
                            autoComplete="off"
                            error={textFieldValue.error && !textFieldValue.height}
                            connectedLeft={
                                <Select
                                    value={textFieldValue.unit}
                                    label={t("Weight unit")}
                                    onChange={handleSelectChange}
                                    labelHidden
                                    options={[{ label: t('cm'), value: 'CENTIMETER' }, { label: t('in'), value: 'INCH' }]}
                                />
                            }
                        />
                    </FormLayout.Group>
                </FormLayout>
            </Modal.Section>
        </Modal>
    </>;
}

export default DI(Package_Dimension)